export const getObjectKeys = (obj: any) => {
  return Object.keys(obj);
};
